import { useMemo } from 'react';

const InitialsAvatar = ({
  name = 'User Name',
  size = 'md',
  className = '',
  color,
  onClick,
  role,
}) => {
  // Get initials from the name
  const initials = useMemo(() => {
    return name
      .split(' ')
      .map((word) => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }, [name]);

  // Size mappings (in pixels)
  const sizeMappings = {
    xs: { width: '24px', height: '24px', fontSize: '0.75rem' },
    sm: { width: '32px', height: '32px', fontSize: '0.875rem' },
    md: { width: '48px', height: '48px', fontSize: '1rem' },
    mdlg: { width: '90px', height: '90px', fontSize: '2rem' },
    lg: { width: '160px', height: '160px', fontSize: '4.25rem' },
    xl: { width: '214px', height: '214px', fontSize: '7.5rem' },
  };

  const sizeStyle = sizeMappings[size] || sizeMappings.md;

  const avatarStyle = {
    backgroundColor: color,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    fontFamily: 'Montserrat-Regular',
    fontWeight: '300',
    ...sizeStyle,
  };

  return (
    <div
      role={role}
      onClick={onClick}
      className={`initials-avatar d-flex align-items-center justify-content-center rounded-circle ${className}`}
      style={avatarStyle}
      aria-label={`Avatar for ${name}`}
    >
      {initials}
    </div>
  );
};

export default InitialsAvatar;
